var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.selectedStatus
        ? _c("ob1-input-chips", {
            attrs: {
              id: "chip-status-id",
              "additional-classes": "mb-1 me-1",
              label: _vm.selectedStatus.primaryText,
            },
            on: {
              "ob1-input-chips-click": function ($event) {
                return _vm.deleteStatusHandler(_vm.selectedStatus)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.filtersBrand
        ? _vm._l(_vm.filtersBrand.checkboxes, function (brand) {
            return _c(
              "span",
              { key: brand.id },
              [
                brand.isChecked
                  ? _c("ob1-input-chips", {
                      attrs: {
                        id: "chip-" + brand.id,
                        "additional-classes": "mb-1 me-1",
                        label: brand.label,
                      },
                      on: {
                        "ob1-input-chips-click": function ($event) {
                          return _vm.deleteBrandHandler(brand)
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(brand.ranges, function (range) {
                  return _c(
                    "span",
                    { key: range.id },
                    [
                      range.isChecked
                        ? _c("ob1-input-chips", {
                            attrs: {
                              id: "chip-" + range.id,
                              "additional-classes": "mb-1 me-1",
                              label: range.label,
                            },
                            on: {
                              "ob1-input-chips-click": function ($event) {
                                return _vm.deleteRangeHandler(
                                  range,
                                  brand,
                                  false
                                )
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
              ],
              2
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.filtersRefurbishedBrand
        ? _vm._l(_vm.filtersRefurbishedBrand.checkboxes, function (brand) {
            return _c(
              "span",
              { key: "refurbished-" + brand.id },
              [
                brand.isChecked
                  ? _c("ob1-input-chips", {
                      key: brand.id,
                      attrs: {
                        id: "chip-" + brand.id,
                        "additional-classes": "mb-1 me-1",
                        label: brand.label + " reconditionnés",
                      },
                      on: {
                        "ob1-input-chips-click": function ($event) {
                          return _vm.deleteBrandRefurbishedHandler(brand)
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(brand.ranges, function (range) {
                  return _c(
                    "span",
                    { key: range.id },
                    [
                      range.isChecked
                        ? _c("ob1-input-chips", {
                            attrs: {
                              id: "chip-" + range.id,
                              "additional-classes": "mb-1 me-1",
                              label: range.label + " reconditionnés",
                            },
                            on: {
                              "ob1-input-chips-click": function ($event) {
                                return _vm.deleteRangeHandler(
                                  range,
                                  brand,
                                  true
                                )
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
              ],
              2
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.filtersBonusRecovery
        ? _vm._l(_vm.filtersBonusRecovery.checkboxes, function (item) {
            return _c(
              "span",
              { key: item.id },
              [
                item.isChecked
                  ? _c("ob1-input-chips", {
                      key: item.id,
                      attrs: {
                        id: "chip-" + item.id,
                        "additional-classes": "mb-1 me-1",
                        label: item.chipsLabel,
                      },
                      on: {
                        "ob1-input-chips-click": function ($event) {
                          return _vm.deleteBonusHandler(item)
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(item.ranges, function (range) {
                  return _c(
                    "span",
                    { key: range.id },
                    [
                      range.isChecked
                        ? _c("ob1-input-chips", {
                            attrs: {
                              id: "chip-" + range.id,
                              "additional-classes": "mb-1 me-1",
                              label: range.label,
                            },
                            on: {
                              "ob1-input-chips-click": function ($event) {
                                return _vm.deleteBonusRangeHandler(range)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
              ],
              2
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.filtersPrice
        ? _vm._l(_vm.filtersPrice.checkboxes, function (price) {
            return _c(
              "span",
              { key: price.id },
              [
                price.isChecked
                  ? _c("ob1-input-chips", {
                      key: price.id,
                      attrs: {
                        id: "chip-" + price.id,
                        "additional-classes": "mb-1 me-1",
                        label: price.label,
                      },
                      on: {
                        "ob1-input-chips-click": function ($event) {
                          return _vm.deletePriceHandler(price)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.filtersRepairability
        ? _vm._l(_vm.filtersRepairability.checkboxes, function (repairability) {
            return _c(
              "span",
              { key: repairability.id },
              [
                repairability.isChecked
                  ? _c("ob1-input-chips", {
                      key: repairability.id,
                      attrs: {
                        id: "chip-" + repairability.id,
                        "additional-classes": "mb-1 me-1",
                        label: _vm.getRepairabilityChipLabel(repairability),
                      },
                      on: {
                        "ob1-input-chips-click": function ($event) {
                          return _vm.deleteRepairabilityHandler(repairability)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.filtersCompatibility
        ? _vm._l(_vm.filtersCompatibility.checkboxes, function (compatibility) {
            return _c(
              "span",
              { key: compatibility.id },
              [
                compatibility.isChecked
                  ? _c("ob1-input-chips", {
                      key: compatibility.id,
                      attrs: {
                        id: "chip-" + compatibility.id,
                        "additional-classes": "mb-1 me-1",
                        label: compatibility.label,
                      },
                      on: {
                        "ob1-input-chips-click": function ($event) {
                          return _vm.deleteCompatibilityHandler(compatibility)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.filtersSegments
        ? _vm._l(_vm.filtersSegments.checkboxes, function (segment) {
            return _c(
              "span",
              { key: segment.id },
              [
                segment.isChecked
                  ? _c("ob1-input-chips", {
                      key: segment.id,
                      attrs: {
                        id: "chip-" + segment.id,
                        "additional-classes": "mb-1 me-1",
                        label: segment.label,
                      },
                      on: {
                        "ob1-input-chips-click": function ($event) {
                          return _vm.deleteSegmentHandler(segment)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.filtersRefurbishedSegments
        ? _vm._l(_vm.filtersRefurbishedSegments.checkboxes, function (segment) {
            return _c(
              "span",
              { key: segment.id },
              [
                segment.isChecked
                  ? _c("ob1-input-chips", {
                      key: segment.id,
                      attrs: {
                        id: "chip-" + segment.id,
                        "additional-classes": "mb-1 me-1",
                        label: segment.label,
                      },
                      on: {
                        "ob1-input-chips-click": function ($event) {
                          return _vm.deleteRefurbishedSegmentHandler(segment)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.filtersOtherSegments
        ? _vm._l(_vm.filtersOtherSegments.checkboxes, function (segment) {
            return _c(
              "span",
              { key: segment.id },
              [
                segment.isChecked
                  ? _c("ob1-input-chips", {
                      key: segment.id,
                      attrs: {
                        id: "chip-" + segment.id,
                        "additional-classes": "mb-1 me-1",
                        label: segment.label,
                      },
                      on: {
                        "ob1-input-chips-click": function ($event) {
                          return _vm.deleteOtherSegmentHandler(segment)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.displayDeleteAllChipsFilterLink
        ? _c("ob1-liens-icone", {
            staticClass: "noDefaultStyleButton mb-1 py-0",
            attrs: {
              mini: "",
              "is-button": true,
              icon: "icon-trash",
              title: _vm.deleteChipsFiltersLabel,
            },
            on: { click: _vm.deleteAllChipsFilterHandler },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }